import React from 'react';
import PropTypes from 'prop-types';
import { SelectFilter } from './Filters/SelectFilter.js';

var SidebarSwitcher = function SidebarSwitcher(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange;
  if (!options) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "sidebar-role-switcher"
  }, /*#__PURE__*/React.createElement(SelectFilter, {
    defaultValue: options[0],
    isClearable: false,
    name: "option_switcher",
    iconKey: "icon",
    onChange: onChange,
    options: options,
    showSelected: true,
    labelKey: "label",
    explainerKey: "description"
  }));
};

SidebarSwitcher.displayName = "SidebarSwitcher";
SidebarSwitcher.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func
};
export { SidebarSwitcher };